<script>


export default {

  name: 'RegTransfer',
  data() {
    return {
      commentMaxLength: 255,
      selectedLocationDestinyTitle: '',
      selectedLocationOriginTitle: '',
      selectedProductName: '',
      managedLocations: [],
      locations: [],
      locationsDestiny: [],
      products: '',
      comment: '',
      transfer: {
        id: 0,
        locationOrigin: 0,
        locationDestiny: 0,
        createdBy: 0,
        dispatchedBy: 0,
        receivedBy: 0,
        createdAt: "0000-01-01T01:01:01-06:00",
        dispatchedAt: "0000-01-01T01:01:01-06:00",
        receivedAt: "0000-01-01T01:01:01-06:00",
        status: 'requested'
      },
      requests: [],
      request: {
        productTransfer: 0,
        product: 0,
        quantity: 0,
      },

    };
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
  },
  methods: {
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }

      try {
        let res = await this.$api.get("/auth/locations/managed");
        if (res.status.toString() === "200") {
          this.managedLocations = res.data
          console.log(this.managedLocations)
          for (let i = 0; i < this.managedLocations.length; i++) {
            let lo = this.locations.find(loc => loc.id === this.managedLocations[i]);
            console.log(typeof lo)
            if (lo !== undefined) {
              this.locationsDestiny.push(lo)
            }
          }
          console.log("Managed locations "+this.managedLocations)
          console.log(typeof this.managedLocations[0])
          console.log(typeof this.locations[0].id)
          console.log(this.locationsDestiny)
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    addRow() {
      for (let i = 0; i < this.requests.length; i++) {
        if (this.requests[i].product === this.request.product) {
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'Ya hay una entrada para este producto en la solicitud.',
            customClass: {
              popup: 'mySwal'
            }
          });
          return
        }
      }

      if (this.request.product < 1 || this.request.quantity <= 0) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Verifique nuevamente los datos del producto a agregar.',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      this.requests.push({
        productTransfer: 0,
        product: this.request.product,
        quantity: this.request.quantity,
      })

      this.selectedProductName = ''
      this.request = {
        productTransfer: 0,
        product: 0,
        quantity: 0,
      }
    },
    async regTransferRequest() {

      console.log("origin "+this.transfer.locationOrigin)
      console.log("destiny "+this.transfer.locationDestiny)

      if (this.transfer.locationOrigin === this.transfer.locationDestiny) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Origen y destino identicos',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }

      let flag = true
      for (let i = 0; i < this.managedLocations.length; i++) {
        if (this.transfer.locationDestiny.toString() === this.managedLocations[i].toString()) {
          flag = false
        }
      }

      if (flag) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Su usuario no tiene permisos de gestion para el destino seleccionado.',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }

      if (this.transfer.locationOrigin < 1 || this.transfer.locationOrigin < 1 || this.requests.length < 1) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Verifique los datos nuevamente',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {

        let formData = new FormData();

        let transferC = {...this.transfer}
        let transferJson = JSON.stringify(transferC);
        formData.append('transfer', transferJson)

        let requestsC = {...this.requests}
        let requestsA = Object.values(requestsC)
        let requestsJson = JSON.stringify(requestsA)
        formData.append('requests', requestsJson)


        formData.append('comment', this.comment)

        let res = await this.$api.post("/auth/transfers", formData);
        if (res.status.toString() === "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              this.transfer = {
                id: 0,
                locationOrigin: 0,
                locationDestiny: 0,
                createdBy: 0,
                dispatchedBy: 0,
                receivedBy: 0,
                createdAt: "0000-01-01T01:01:01-06:00",
                dispatchedAt: "0000-01-01T01:01:01-06:00",
                receivedAt: "0000-01-01T01:01:01-06:00",
                status: ''
              }
              this.requests = []
              this.selectedLocationOriginTitle = ''
              this.selectedLocationDestinyTitle = ''
              this.selectedProductName = ''

              this.request = {
                productTransfer: 0,
                product: 0,
                quantity: 0,
              }

            this.$router.push({name:'ShowTransfer', params:{id:res.data}})
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar la solicitud de transferencia',
          customClass: {
            popup: 'mySwal'
          }
        });
        this.requests = []
      }
    },
    getIDLocationOrigin() {
      let selectedItem = this.locations.find(location => location.name.trim() === this.selectedLocationOriginTitle.trim());
      if (selectedItem !== undefined) {
        this.transfer.locationOrigin = selectedItem.id
        this.locationsDestiny = this.locations.filter(location => location.id !== selectedItem.id)
        console.log("location destiny "+this.locationsDestiny.length)
      } else {
        this.transfer.locationOrigin = 0;
        this.locationsDestiny = []
        this.transfer.locationDestiny = 0;
        this.selectedLocationDestinyTitle = '';
      }
    },
    getIDLocationDestiny() {
      let selectedItem = this.locationsDestiny.find(location => location.name.trim() === this.selectedLocationDestinyTitle.trim());
      if (selectedItem !== undefined) {
        this.transfer.locationDestiny = selectedItem.id
      }
    },
    getIDProduct() {
      let selectedItem = this.products.find(product => product.title.trim() === this.selectedProductName.trim());
      if (selectedItem !== undefined) {
        this.request.product = selectedItem.id
      } else {
        this.request.product = 0
      }
    },
    getProductById(id) {
      return this.products.find(prod => prod.id === id) || {};
    },
    deleteProduct(index) {
      this.requests.splice(index, 1)
    },
    inputLimiterComments() {
      this.comment = this.comment.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart()
      if (this.comment.length > this.commentMaxLength) {
        this.comment = this.comment.substring(0, this.commentMaxLength)
      }
    }
  },
  created() {
    this.getLocation()
    this.getProd()
  },
}

</script>

<template>

  <div id="section-0" class="container">


    <div class="form-reg-user">
      <h1>Registrar Transferencia</h1>
      <form class="Form">
        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Origen</label>
            <input list="locations" v-model="selectedLocationOriginTitle" @input="getIDLocationOrigin">
            <datalist id="locations">
              <option v-for="loc in locations" :key="loc.id" :value="loc.name"></option>
            </datalist>


            <!-- more elements... -->
          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Destino</label>
            <input list="locationsDestiny" v-model="selectedLocationDestinyTitle" @input="getIDLocationDestiny" :disabled="transfer.locationOrigin === 0">
            <datalist id="locationsDestiny">
              <option v-for="loc in locationsDestiny" :key="loc.id" :value="loc.name"></option>
            </datalist>


            <!-- more elements... -->
          </div>
        </div>

        <div style="margin-bottom: 25px; margin-left: auto; margin-right: auto;">
          <h3 >Agregar comentario</h3>
        </div>

        <div style="position: relative; width: 706px; margin-left: auto; margin-right: auto;">
        <textarea v-model="comment" style="height: 65px; width: 682px;" v-on:input="inputLimiterComments"></textarea>
          <span style="position: absolute; bottom: 5px; right: 10px; font-size: 12px; color: grey;">
            {{ comment.length }}/{{ commentMaxLength}}
          </span>
        </div>

        <h2>Detalle de la tranferencia</h2>

        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Producto</label>
            <input list="products" v-model="selectedProductName" @input="getIDProduct">
            <datalist id="products">
              <option v-for="product in products" :key="product.id" :value="product.title"></option>
            </datalist>

          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Cantidad</label>
            <input type="number" step="1" placeholder="00" v-model="request.quantity">

            <!-- more elements... -->
          </div>
        </div>

        <button id="addRow" @click.prevent="addRow">Agregar</button>

        <div class="container mt-4 table-container" v-if="requests.length">
          <table id="myTable">
            <thead>
            <tr>
              <th>#</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th></th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(request, index) in requests" :key="index">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ getProductById(request.product).title }}</td>
              <td>{{ request.quantity }}</td>
              <td class="td_align_center">
                <button class="tableBtn" type="submit" @click.prevent="deleteProduct(index)">Eliminar</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <p class="bordered-p">No se han registrado productos aun</p>
        </div>


        <button type="submit" @click.prevent="regTransferRequest">Registrar</button>
      </form>
    </div>

  </div>
</template>


<style scoped>
</style>